import { toDateString } from "../../../../shared/types/date-helpers";

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportJson(
  tasks: unknown[],
  events: unknown[],
  habits: unknown[],
) {
  const data = { tasks, events, habits };
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const dateStr = toDateString(new Date());
  downloadBlob(blob, `palnia-backup-${dateStr}.json`);
}

export function exportICalendar(events: unknown[]) {
  let ical = "BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//Palnia//EN\n";

  for (const event of events as Array<{
    date: string;
    startTime: string;
    endTime: string;
    title: string;
    description?: string;
    id: string;
  }>) {
    const startDate = event.date.replace(/-/g, "");
    const startTime = event.startTime.replace(/:/g, "");
    const endTime = event.endTime.replace(/:/g, "");

    ical += "BEGIN:VEVENT\n";
    ical += `DTSTART:${startDate}T${startTime}00\n`;
    ical += `DTEND:${startDate}T${endTime}00\n`;
    ical += `SUMMARY:${event.title}\n`;
    if (event.description) {
      ical += `DESCRIPTION:${event.description}\n`;
    }
    ical += `UID:${event.id}\n`;
    ical += "END:VEVENT\n";
  }

  ical += "END:VCALENDAR";
  const blob = new Blob([ical], { type: "text/calendar" });
  const dateStr = toDateString(new Date());
  downloadBlob(blob, `palnia-events-${dateStr}.ics`);
}

export function validateImportedData(parsed: unknown): {
  tasks: unknown[];
  events: unknown[];
  habits?: unknown[];
} {
  if (typeof parsed !== "object" || parsed === null) {
    throw new Error("Format invalide");
  }

  if (!("tasks" in parsed) || !("events" in parsed)) {
    throw new Error("Format invalide");
  }

  const data = parsed as { tasks: unknown; events: unknown; habits?: unknown };

  if (!Array.isArray(data.tasks) || !Array.isArray(data.events)) {
    throw new Error("Format invalide");
  }

  if (data.habits && !Array.isArray(data.habits)) {
    throw new Error("Format des habitudes invalide");
  }

  return {
    tasks: data.tasks,
    events: data.events,
    habits: Array.isArray(data.habits) ? data.habits : [],
  };
}
